.firstVisit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--qs-space-32);
  width: 100%;
  padding: var(--qs-space-32) 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--qs-space-12);
  width: 100%;
  max-width: var(--qs-layout-column-wide);
  border: none;
  padding: 0;
  margin: 0;

  @media (max-width: 719px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.item {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--qs-space-8);
  min-height: 52px;
  padding: 0 var(--qs-space-16);
  border-radius: var(--qs-radius-md);
  border: 1px solid var(--qs-color-line);
  cursor: pointer;
  transition: border-color var(--qs-motion-dur-fade) var(--qs-motion-ease-settle);

  input {
    position: absolute;
    inset: 0;
    opacity: 0;
    margin: 0;
    cursor: pointer;
  }

  &:hover {
    border-color: var(--qs-color-line-strong);
  }

  &.selected {
    border-color: var(--qs-color-text);
    background: var(--qs-color-surface-raised);
  }

  &:focus-within {
    outline: 2px solid var(--qs-color-focus);
    outline-offset: 2px;
  }
}

.flag {
  font-size: 20px;
  line-height: 1;
}

.endonym {
  font-family: var(--qs-font-text);
  font-weight: 300;
  font-size: var(--qs-type-body-size);
  color: var(--qs-color-text-soft);
}

.voiceRow {
  width: 100%;
  max-width: 420px;
  animation: fadeIn var(--qs-motion-dur-settle) var(--qs-motion-ease-settle);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

// In-session trigger + popover ---------------------------------------------

.container {
  position: relative;
}

.trigger {
  display: flex;
  align-items: center;
  gap: var(--qs-space-4);
  min-width: var(--qs-target-min);
  min-height: var(--qs-target-min);
  padding: 0 var(--qs-space-12);
  border: none;
  border-radius: var(--qs-radius-pill);
  background: transparent;
  color: var(--qs-color-text-soft);
  cursor: pointer;
  transition: opacity var(--qs-motion-dur-fade) var(--qs-motion-ease-settle);

  &:hover:not(:disabled) {
    color: var(--qs-color-text);
  }

  &.disabled,
  &:disabled {
    opacity: 0.45;
    pointer-events: none;
  }
}

.isoCode {
  font-size: var(--qs-type-label-size);

  @media (max-width: 719px) {
    display: none;
  }
}

.popover {
  position: absolute;
  top: calc(100% + var(--qs-space-8));
  left: 0;
  width: 300px;
  max-height: 340px;
  overflow-y: auto;
  padding: var(--qs-space-8);
  border-radius: var(--qs-radius-md);
  background: var(--qs-color-surface-raised);
  border: 1px solid var(--qs-color-line);
  box-shadow: var(--qs-elev-popover);
  z-index: 40;
  animation: settle var(--qs-motion-dur-settle) var(--qs-motion-ease-settle);

  @media (max-width: 719px) {
    position: fixed;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    max-height: 60vh;
    border-radius: var(--qs-radius-lg) var(--qs-radius-lg) 0 0;
  }
}

@keyframes settle {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.rows {
  list-style: none;
  margin: 0;
  padding: 0;
}

.row {
  display: flex;
  align-items: center;
  gap: var(--qs-space-12);
  width: 100%;
  min-height: 48px;
  padding: 0 var(--qs-space-12);
  border: none;
  background: transparent;
  border-radius: var(--qs-radius-sm);
  color: var(--qs-color-text-soft);
  cursor: pointer;
  text-align: left;

  &:hover {
    background: var(--qs-color-surface);
  }

  &[aria-current="true"] {
    color: var(--qs-color-text);
  }
}

.check {
  margin-left: auto;
  color: var(--qs-color-accent);
}

.pinned {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--qs-space-24);
  width: 100%;

  @media (max-width: 719px) {
    position: sticky;
    bottom: 0;
    z-index: 1;
    padding: var(--qs-space-32) 0 var(--qs-space-16);
    background: linear-gradient(to bottom, transparent, var(--qs-color-ground) var(--qs-space-32));
  }
}

.begin {
  @media (max-width: 719px) {
    width: 100%;
  }
}

.note {
  margin: calc(var(--qs-space-12) * -1) 0 0;
  max-width: 32ch;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--qs-color-text-soft);
}
